export const colors = {
  primary: '#24A0ED',
  success: '#569D4F',
  lightSuccess: '#F0FDF4',
  darkDeem: '#666666',
  lightDeem: '#CCCCCC',
  black: '#000000',
  red: '#f03e3e',
  lightRed: '#ff6e6e',
  danger: '#AB3022',
  lightDanger: '#FDEBEB',
  light: '#F2F9FE',
  white: '#FFFFFF',
  gray: '#ebebeb',
  yellow: '#F7B801',
  // lightGray: '#EFEFEF',
  lightGray: '#F8F8F8',
  lightGrey: '#E3E3E3',
  StrokeLight: '#666',

  darkBlue: '#5263FA',
  lightBlue: '#5462ff',
  faintBlue: '#a8c6ff59',
  softBlue: '#edf3ff',
  softGrey: '#868e96',
};
